import { BarChart, Bar, Tooltip, Cell, ResponsiveContainer } from 'recharts'
import { toolBarColor } from '@lens/lib/tool-categories'
import type { ToolSummary } from '@lens/types/claude'
import { CHART_TOOLTIP_STYLE, ChartGrid, ChartXAxis, ChartYAxis } from '../chart-primitives'
import { SectionHeading } from '../../section-heading'

interface Props {
 tools: ToolSummary[]
}

export function ToolRankingChart({ tools }: Props) {
 const top = tools.slice(0, 20)

 return (
  <div>
   <SectionHeading as="h3" className="mb-3" title="Tool Usage — Ranked by Total Calls" />
   <ResponsiveContainer width="100%" height={Math.max(200, top.length * 26)}>
    <BarChart data={top} layout="vertical" margin={{ top: 0, right: 60, bottom: 0, left: 8 }}>
     <ChartGrid horizontal={false} />
     <ChartXAxis type="number" tickFormatter={(v: number) => v.toLocaleString()} />
     <ChartYAxis type="category" dataKey="name" width={110} />
     <Tooltip
      contentStyle={CHART_TOOLTIP_STYLE}
      formatter={(val, _name, props) => {
       const num = typeof val === 'number' ? val : 0
       const payload = (props as { payload?: { name?: string } } | undefined)?.payload
       return [num.toLocaleString() + ' calls', payload?.name ?? '']
      }}
     />
     <Bar dataKey="total_calls" radius={[0, 3, 3, 0]} isAnimationActive={false}>
      {top.map((tool, i) => (
       <Cell key={i} fill={toolBarColor(tool.name)} fillOpacity={0.92} />
      ))}
     </Bar>
    </BarChart>
   </ResponsiveContainer>
  </div>
 )
}
